import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./cookies_popup.module.css";
import { IPopupWithoutProps } from "../../../types/types";

function SignupSuccessPopup({ onClose }: IPopupWithoutProps) {
  return (
    <article className={popupStyles.popup}>
      <button
        className={`${popupStyles.popup__closeBtn} hover`}
        onClick={onClose}
      />
      <h2 className={popupStyles.popup__title}>{t('WELCOME_MESSAGE')}</h2>
      <p className={popupStyles.popup__text}>{t('WE_DONT_KEEP_IT_INSIDE')}</p>
      <p className={popupStyles.popup__text}>
        {t('USING_COOKIES_FOR_BETTER_EXPERIENCE')}</p>
      <p className={popupStyles.popup__text}>
        {t('AGREE_TO_ALL_COOKIES')}</p>
      <p className={popupStyles.popup__text}>
        {t('EDIT_COOKIES_SETTINGS')}</p>
      <button
        className={`button ${popupStyles.popup__nextBtn} hover`}
        onClick={onClose}
      >
        {t('I_AGREE_TO_EVERYTHING')}</button>
      <button
        className={`button ${popupStyles.popup__nextBtn} ${popupStyles.popup__nextBtn_white} hover`}
        onClick={onClose}
      >
        {t('COOKIES_SETTINGS')}</button>
    </article>
  );
}

export default SignupSuccessPopup;
